import { airTankTypes, DeviceType, sensorTypes, valveTypes } from '@/constants/deviceTypeEnum';

export const SCC_BLACKLIST_TYPES: DeviceType[] = [
  ...sensorTypes,
  ...valveTypes,
  ...airTankTypes,
  DeviceType.ConverterDigitalAnalogToModbus,
  DeviceType.PLC,
  DeviceType.AirFilter,
  DeviceType.Connector,
  DeviceType.AmbientHumiditySensor,
  DeviceType.AmbientTemperatureSensor,
  DeviceType.AmbientHumidityAndTemperatureSensor,
  DeviceType.AmbientHumidityAndTemperatureAndDewpointSensor,
  DeviceType.AerationBasin,
  DeviceType.ProductionFloor,
  DeviceType.Pipe,
];
